import styled, { css } from 'styled-components';

import { Cross, Plus } from '@xsolla/ui-icons';

export const TagSelectorWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const activeTagStyles = css`
  background-color: ${(props) => props.theme.colors.brand};
  border: 1px solid ${(props) => props.theme.colors.brand};
  color: ${(props) => props.theme.colors.white};
`;

const hoverTagStyles = css`
  :hover {
    background-color: #f5f9ff;
    border: 1px solid ${(props) => props.theme.colors.brand};
  }
`;

export const TagItem = styled.div<{ active?: boolean }>`
  ${(props) => props.theme.typography.body};
  display: flex;
  align-items: center;
  padding: 5px 10px;
  margin: 0 5px 8px 0;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.stroke};
  cursor: pointer;
  ${(props) => props.active && activeTagStyles}
  ${(props) => !props.active && hoverTagStyles}
`;

export const CrossTagIcon = styled(Cross)`
  color: ${(props) => props.theme.colors.brand};
  background-color: #00244d;
  margin-right: 4px;
  border-radius: 50%;
`;

export const PlusTagIcon = styled(Plus)`
  color: ${(props) => props.theme.colors.brand};
  margin-right: 4px;
`;
